import script from "./hotel-tab.vue?vue&type=script&setup=true&lang=js"
export * from "./hotel-tab.vue?vue&type=script&setup=true&lang=js"

import "./hotel-tab.vue?vue&type=style&index=0&id=92d42a8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92d42a8c"]])

export default __exports__